/*@ngInject*/
const CollaborationUserAvatarDirective = function (collaborationUtil) {

    let linkFunction = function ($scope, $elm, $attrs) {

        $scope.$watch('toorccusers', function (newValue) {
            if (newValue) {
                $scope.toOrCcUserList = JSON.parse(newValue);
            }
        });

        $scope.getRecipientString = function (user) {
            if (user.emailAddress) {
                return collaborationUtil.getEmailIdentifierString(user.name, user.emailAddress);
            } else {
                return user;
            }
        };
    };

    return {
        restrict: 'E',
        scope: {
            label: '@',
            text: '@',
            userid: '@',
            toorccusers: '@',
            sublabel: '@',
            emailId: '@',
        },
        link: linkFunction,
        templateUrl: '/collaboration/collaborationUserAvatar.tpl.html'
    };
};

angular.module('gw-um-submission')
    .directive('collaborationUserAvatar', CollaborationUserAvatarDirective);
